import React from "react";
import { Redirect } from "react-router-dom";
import { useThemeContext } from "../../../../contexts/ThemeContext/ThemeContext";
import DashboardLayout from "../../layouts/DashboardLayout";
import localeText from "../../../../locale";
import cardFidelity from "./card_fidelity.png";
import "./MyCards.css";

const card = {
  number: "1234567",
  validad: "12/24",
};

const MyCards = ({ userInfo }) => {
  const { subnetInfo } = useThemeContext();
  const firstname = userInfo?.firstname || "";
  const surname = userInfo?.surname || "";

  if (Number(subnetInfo?.id) !== 2) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <DashboardLayout>
      <nav
        className="flex align-items-center gap-2 mb-2 text-sm"
        style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
        aria-label="Breadcrumb"
      >
        <span style={{ color: "var(--theme-text, #171717)" }}>{localeText("myCards")}</span>
      </nav>

      <div className="mb-4">
        <h1 className="text-xl font-semibold m-0" style={{ color: "var(--theme-text, #171717)" }}>
          {localeText("myCards")}
        </h1>
        <p className="text-sm m-0 mt-1" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
          {localeText("myCardsSubtitle")}
        </p>
      </div>

      <div className="my-cards-wrapper">
        <div className="my-fidelity-card">
          <img src={cardFidelity} alt="Cartão Fidelidade" className="my-fidelity-card__img" />

          <p
            className="my-fidelity-card__number"
            style={{ color: "#B8C7CE", fontFamily: "Roboto, sans-serif", fontSize: "2rem" }}
          >
            Card Number <span>{card.number}</span>
          </p>

          <p
            className="my-fidelity-card__rewards"
            style={{
              color: "#B4A173",
              fontFamily: "Roboto, sans-serif",
              fontSize: ".9rem",
            }}
          >
            PROGRAMMA REWARDS
          </p>

          <p
            className="my-fidelity-card__member"
            style={{ color: "#B4A173", fontFamily: "Roboto, sans-serif", fontSize: ".9rem" }}
          >
            Membro dal: 2026
          </p>

          <div className="my-fidelity-card__validity">
            <p style={{ color: "#B4A173", fontFamily: "Roboto, sans-serif", fontSize: ".9rem" }}>
              VALIDA FINO AL: {card.validad}
            </p>

            <p style={{ color: "#B4A173", fontFamily: "Roboto, sans-serif", fontSize: "1.4rem" }}>
              {firstname} {surname}
            </p>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default MyCards;
